var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 1C6 0.601562 6.32812 0.25 6.75 0.25H9.72656C9.84375 0.25 9.9375 0.273438 10.0312 0.320312C10.1016 0.34375 10.1953 0.414062 10.2656 0.484375C10.4062 0.625 10.4766 0.8125 10.5 1V4C10.5 4.42188 10.1484 4.75 9.75 4.75C9.32812 4.75 9 4.42188 9 4V2.82812L5.01562 6.78906C4.73438 7.09375 4.24219 7.09375 3.96094 6.78906C3.65625 6.50781 3.65625 6.01562 3.96094 5.73438L7.92188 1.75H6.75C6.32812 1.75 6 1.42188 6 1ZM0 2.5C0 1.67969 0.65625 1 1.5 1H3.75C4.14844 1 4.5 1.35156 4.5 1.75C4.5 2.17188 4.14844 2.5 3.75 2.5H1.5V9.25H8.25V7C8.25 6.60156 8.57812 6.25 9 6.25C9.39844 6.25 9.75 6.60156 9.75 7V9.25C9.75 10.0938 9.07031 10.75 8.25 10.75H1.5C0.65625 10.75 0 10.0938 0 9.25V2.5Z",
    fill: "#27AE60"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/link-icon.b18d0e6e556125434eca229f31166772.svg";
export { ForwardRef as ReactComponent };